<template>
  <div
      v-if="readOnlyOrLocked"
      class="border border-gray-200 m-0 w-full resize-none overflow-x-auto whitespace-nowrap shadow-none relative hover:z-10 focus:z-20"
      v-text="effectiveFormat(value)"
      @mouseenter="$emit('mouseenter', $event)"
      @mouseleave="$emit('mouseleave', $event)"
  ></div>
  <textarea
      v-else
      :placeholder="placeholder"
      type="text"
      class="resize-none overflow-x-auto whitespace-nowrap shadow-none relative hover:z-10 focus:z-20"
      :value="focused ? value : effectiveFormat(value)"
      @input="$emit('input', $event.target.value)"
      @change="$emit('change', $event.target.value)"
      @keydown.enter.prevent="$emit('change', $event.target.value)"
      @focus="focused = true; selectAll($event);"
      @blur="focused = false"
      @mouseenter="$emit('mouseenter', $event)"
      @mouseleave="$emit('mouseleave', $event)"
      rows="1"
  ></textarea>
</template>

<script>
import {estimateStore} from '@stores'
import {toCurrency} from '@utils'

export default {
  props: {
    value: null,
    placeholder: String,
    currency: Boolean,
    decimals: {
      type: Number,
      default: 2,
    },
    readOnly: Boolean,
    format: {
      type: Function,
      default: value => value,
    },
  },
  data() {
    return {
      focused: false,
    }
  },
  computed: {
    $store() {
      return estimateStore
    },
    estimate() {
      return this.$store.state.estimate
    },
    readOnlyOrLocked() {
      return this.estimate?.cannot_be_edited_by_authed_user ?? this.readOnly
    },
  },
  methods: {
    effectiveFormat(value) {
      return this.currency ? toCurrency(value, 'GBP', this.decimals) : this.format(value)
    },
    selectAll(event) {
      // Work around unselect on mouseup issue on Safari.
      event.target.addEventListener('mouseup', function (event) {
        event.preventDefault()
        event.stopPropagation()
        return false
      }, {once: true})

      this.$nextTick(() => {
        event.target.setSelectionRange(0, event.target.value.length)

        // Work around Safari's delay when focusing elements.
        setTimeout(() => {
          event.target.setSelectionRange(0, event.target.value.length)
        }, 10);
      })
    },
  },
}
</script>
